import React from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import ItemSelect from "../../shared/Input/ItemSelect";
import {Selector_ServiceCategories_Listing_Root} from "../../../store/selectors/Selectors_ServiceCategories";
import {Thunk_ServiceCategories_Fetch_All} from "../../../store/thunk/Thunk_ServiceCategories";

class ServiceCategorySelect extends React.Component {
	render() {
		const {Thunk_ServiceCategories_Fetch_All} = this.props;

		return <ItemSelect
			thunk={Thunk_ServiceCategories_Fetch_All}
			selector={Selector_ServiceCategories_Listing_Root}
			label={"serviceCategory_select"}
			headerItems={{name: {}, id: {}}}
			{...this.props}
		/>
	}

	static get propCategories() {
		return ItemSelect.propTypes
	}
}

const mapDispatchToProps = dispatch => (
	bindActionCreators({
		Thunk_ServiceCategories_Fetch_All
	}, dispatch)
);

export default connect(null, mapDispatchToProps)(ServiceCategorySelect);
